import React, { ComponentPropsWithRef } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { MTypo } from '../components/MTypo/MTypo'
import type { TypographyVariant } from '../types/mui'

interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}
/**
 * @param p
 * @returns
 */
export const HowToWorkEnv = (p: Props) => {
    const commons = useCommonCtx()
    const t = useTranslation(commons)
    const { className, titleV, bodyV, ...rest } = p

    const {
        state: { params: {brandParams} },
    } = commons

    return (
        <div className="flex flex-1 flex-col justify-center items-center">
        <MTypo variant={titleV} 
            outerClassName='mb-12'
            textClassName="text-center">
            {t('howto_workenv_title')}
        </MTypo>
        <MTypo variant={bodyV} className="text-justify">
            {t('howto_workenv_body')}
        </MTypo>
    </div>
    )
}
